import { DropdownMenuItem } from "@workspace/frontend-ui";
import LinkComponent from "@workspace/nextjs_utils/src/components/LinkComponent";
import type { FC } from "react";
import SidebarIcon from "../../Sidebar/SidebarView/SidebarSection/SidebarIcon";
import type { ProfileMenuEntry } from "./types";

type Props = {
  item: ProfileMenuEntry;
  badge?: number;
};

const ProfileMenuItem: FC<Props> = ({ item, badge }) => {
  const badgeEl = badge ? (
    <span
      data-slot="profile-badge"
      className="flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 font-medium text-primary-foreground text-sm"
    >
      {badge}
    </span>
  ) : null;

  return (
    <DropdownMenuItem
      asChild
      className="cursor-pointer gap-3 rounded-lg px-2.5 py-2.5 not-data-[variant=destructive]:focus:[&_[data-slot=profile-badge]]:text-primary-foreground"
    >
      <LinkComponent href={item.href ?? "#"}>
        <SidebarIcon icon={item.icon} hugeIcon={item.hugeIcon} />
        <span className="flex-1 truncate font-medium text-foreground text-sm">
          {item.label}
        </span>
        {badgeEl}
      </LinkComponent>
    </DropdownMenuItem>
  );
};

export default ProfileMenuItem;
